import { TIN_FORMAT_REGEX, VALIDATE_NAME_REGEX, VALIDATE_ZIP_CODE_REGEX } from "../../../../libs/utility/constants";
import { PAGE_STATE, RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, SPACE_NOT_ALLOWED_IN_CLIENT_ID_TEXT, SPACE_AND_SPECIAL_CHARACTERS_NOT_ALLOWED_TEXT } from "../../constants/constants";

export const ADD_PAYER_SLICE_INITIAL_STATE = {
    methodType: null,
    PayerType: null,

    basicInfo: {
        allRequiredFieldsTouched: false,

        PayerFirstName: {
            value: "",
            errors: {},
            rules: { required: false, regex: { pattern: VALIDATE_NAME_REGEX, message: "A valid payer name should only consist any of A-Z,a-z, 0-9,-,.&' letters and maximum 40 character" }}
        },

        PayerMiddleName: { value: "", errors: {}, rules: { required: false, regex: { pattern: VALIDATE_NAME_REGEX, message: "A valid payer name should only consist any of A-Z,a-z, 0-9,-,.&' letters and maximum 40 character" } } },

        PayerLastName: { value: "", errors: {}, rules: { required: true, regex: { pattern: VALIDATE_NAME_REGEX, message: "A valid payer name should only consist any of A-Z,a-z, 0-9,-,.&' letters and maximum 40 character" } } },

        TIN: { value: "", errors: {}, rules: { required: true, regex: { pattern: TIN_FORMAT_REGEX, message: "Please Enter a Valid TIN" } } },

        PayerEmail: {
            value: "",
            errors: {},
            rules: { required: false, regex: { pattern: /^\S+@\S+\.\S+$/, message: "Please enter a valid email address" } }
        },

        PayerPhNo: {
            value: "",
            errors: {},
            rules: { required: true, minLength: 8, maxLength: 15 }
        },

        PayerFileType: { value: "", errors: {} },
        PayerSuffix: {
            label: "--Select--",
            value: "SEL",
            errors: {},
            rules: { required: false }
        },
    },

    addressInformation: {
        allRequiredFieldsTouched: false,

        PayerAddress: {
            value: "",
            errors: {},
            rules: { required: true, maxLength: 48, regex: { pattern: /^(?=.*[A-Za-z0-9])[A-Za-z0-9 .\-,#/]*$/, message: "Please enter a valid address with at least one letter. Special characters alone are not allowed." } }
        },
        PayerAddress2: { 
            value: "",
            errors:{},
            rules: { required: false, maxLength: 48, regex: { pattern: /^(?=.*[A-Za-z0-9])[A-Za-z0-9 .\-,#/]*$/, message: "Please enter a valid address with at least one letter. Special characters alone are not allowed." } }
        },
        PayerCountry: {
            label: "",
            value: "",
            errors: {},
            rules: { required: true }
        },
        PayerState: {
            label: "",
            value: "",
            errors: {},
            rules: { required: true }
        },
        PayerCity: {
            value: "",
            errors: {},
            rules: { required: true, regex: { pattern: /^[a-zA-Z ]+$/, message: "Please enter a valid city name. The name should not contain any numbers" } }
        },
        PayerZIP: {
            value: "",
            errors: {},
            rules: { required: true, regex: { pattern: VALIDATE_ZIP_CODE_REGEX, message: "Please enter a valid ZIP Code. The ZIP Code should only contain numbers" } }
        },
    },

    optionalInformation: {
        allRequiredFieldsTouched: false,
        DisregardedEntity: {
            value: "",
            errors: {},
            rules: { required: true }
        },
        ClientID: {
            value: "",
            errors: {},
            rules: { required: true, regex: { pattern: RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, message: SPACE_NOT_ALLOWED_IN_CLIENT_ID_TEXT } }
        },
        UnMaskRecipientTIN: {
            value: false,
            errors: {},
        },
        StateID: {
            value: "",
            errors: {},
            rules: { required: false, regex: { pattern: RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, message: SPACE_AND_SPECIAL_CHARACTERS_NOT_ALLOWED_TEXT } }
        },
        GroupID: {
            value: "",
            errors: {},
        }
    },

    PayerDetailId: "",
    UserId: "",

    payerCreationSuccessful: false,
    zipCodeValidationSuccess: false,
    loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
    payerUpdationSuccessful: false,
    newlyAddedPayer: {},
    showAssignToUserTable: false,
};

export const PAYER_SSN_TOOLTIP = { id: "ssn-tooltip", label: "Social security number (SSN)", tooltipText: "The SSN identifies U.S. citizens and is used to determine benefits & track income." };

export const PAYER_EIN_TOOLTIP = { id: "ein-tooltip", label: "Employer Identification Number (EIN)", tooltipText: "An EIN identifies businesses in the US" };

export const ADD_PAYER_LOADING_STATES = {
    ADD_SINGLE_PAYER_LOADING: "ADD_SINGLE_PAYER_LOADING",
    ADD_SINGLE_PAYER_READY: "ADD_SINGLE_PAYER_READY",
    VALIDATE_ZIP_CODE_LOADING: "VALIDATE_ZIP_CODE_LOADING",
    VALIDATE_ZIP_CODE_READY: "VALIDATE_ZIP_CODE_READY",
    EDIT_PAYER_LOADING: "EDIT_PAYER_LOADING",
    EDIT_PAYER_READY: "EDIT_PAYER_READY",
    GET_PAYER_DATA_LOADING: "GET_PAYER_DATA_LOADING",
    GET_PAYER_DATA_READY: "GET_PAYER_DATA_READY",
    GET_TEMPLATE_LOADING:"GET_TEMPLATE_LOADING",
    GET_TEMPLATE_READY: "GET_TEMPLATE_READY",
    UPLOAD_FILE_LOADING: "UPLOAD_FILE_LOADING",
    UPLOAD_FILE_READY: "UPLOAD_FILE_READY",
    VALIDATE_SHEET_RECORD_LOADING: "VALIDATE_SHEET_RECORD_LOADING",
    VALIDATE_SHEET_RECORD_READY: "VALIDATE_SHEET_RECORD_READY"
}

export const ADD_PAYER_LOADING_MESSAGE_MAP = {
    [ADD_PAYER_LOADING_STATES.ADD_SINGLE_PAYER_LOADING]: "Adding Payer...",
    [ADD_PAYER_LOADING_STATES.VALIDATE_ZIP_CODE_LOADING]: "Validating Zipcode...",
    [ADD_PAYER_LOADING_STATES.VALIDATE_ZIP_CODE_LOADING]: "Validating Zipcode...",
    [ADD_PAYER_LOADING_STATES.EDIT_PAYER_LOADING]: "Updating Payer Information...",
    [ADD_PAYER_LOADING_STATES.GET_TEMPLATE_LOADING]: "Downloading Template...",
    [ADD_PAYER_LOADING_STATES.UPLOAD_FILE_LOADING]: "Uploading file...",
    [ADD_PAYER_LOADING_STATES.VALIDATE_SHEET_RECORD_LOADING]: "Validating Records...",
}
export const PAYER_PHONE_NUM_FIELD_NAME = "PayerPhNo"
export const PAYER_BUSINESS_FIELD_NAME= "PayerLastName"

export const PAYER_SUFFIX_OPTIONS = [
    { value: 'SEL', label: '--Select--' },
    { value: 'Jr', label: 'Jr' },
    { value: 'Sr', label: 'Sr' },
    { value: '2nd', label: '2nd' },
    { value: 'C3rd', label: 'C3rd' },
    { value: 'II', label: 'II' },
    { value: 'III', label: 'III' },
    { value: 'IV', label: 'IV' },
    { value: 'V', label: 'V' },
    { value: 'VI', label: 'VI' }
]
